// ─── Supported Locales ──────────────────────────────────────────────────────
// 16 languages supported for menu translations.

export const LOCALES = [
  'en', 'ar', 'id', 'hi', 'ur', 'fr', 'es', 'cs',
  'de', 'pt', 'nl', 'it', 'zh', 'ko', 'ja', 'ru',
] as const;

export type Locale = (typeof LOCALES)[number];

export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  ar: 'العربية (Arabic)',
  id: 'Indonesian',
  hi: 'हिन्दी (Hindi)',
  ur: 'اردو (Urdu)',
  fr: 'Français',
  es: 'Español',
  cs: 'Čeština',
  de: 'Deutsch',
  pt: 'Português',
  nl: 'Nederlands',
  it: 'Italiano',
  zh: '中文 (Chinese)',
  ko: '한국어 (Korean)',
  ja: '日本語 (Japanese)',
  ru: 'Русский (Russian)',
};

export const RTL_LOCALES: readonly Locale[] = ['ar', 'ur'];

export function isRTL(locale: Locale): boolean {
  return RTL_LOCALES.includes(locale);
}

export function getDirection(locale: Locale): 'ltr' | 'rtl' {
  return isRTL(locale) ? 'rtl' : 'ltr';
}
